export function preventFullscreen(videoEl) {
  // iPhone以外では処理しない
  if (typeof window !== 'undefined' && !window.isIphone) return;
  if (!videoEl) return;
  videoEl.setAttribute('playsinline','');
  videoEl.setAttribute('webkit-playsinline','');
  videoEl.setAttribute('x5-playsinline','');
  videoEl.playsInline = true;
  videoEl.disablePictureInPicture = true;
  videoEl.disableRemotePlayback   = true;
  
  // CSSでボタンを隠す（1回だけ head に挿入）
  if (!document.getElementById('no-fullscreen-controls')) {
    const st = document.createElement('style');
    st.id = 'no-fullscreen-controls';
    st.textContent = `
        .storeeel-campaign-container video::-webkit-media-controls-fullscreen-button,
        .storeeel-campaign-container video::-webkit-media-controls-enter-fullscreen-button,
        .storeeel-campaign-container video::-webkit-media-controls-exit-fullscreen-button,
        .storeeel-campaign-container video::-webkit-media-controls-picture-in-picture-button,
        .storeeel-modal video::-webkit-media-controls-fullscreen-button,
        .storeeel-modal video::-webkit-media-controls-enter-fullscreen-button,
        .storeeel-modal video::-webkit-media-controls-exit-fullscreen-button,
        .storeeel-modal video::-webkit-media-controls-picture-in-picture-button,
        video.storeeel-content-movie::-webkit-media-controls-fullscreen-button,
        video.storeeel-content-movie::-webkit-media-controls-enter-fullscreen-button,
        video.storeeel-content-movie::-webkit-media-controls-exit-fullscreen-button,
        video.storeeel-content-movie::-webkit-media-controls-picture-in-picture-button,
        video.storeeel-movie::-webkit-media-controls-fullscreen-button,
        video.storeeel-movie::-webkit-media-controls-enter-fullscreen-button,
        video.storeeel-movie::-webkit-media-controls-exit-fullscreen-button,
        video.storeeel-movie::-webkit-media-controls-picture-in-picture-button {
          display: none !important;
        }
      `;
    document.head.appendChild(st);
  }

  // 標準 Fullscreen API の抑制
  document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  });
  document.addEventListener('webkitfullscreenchange', () => {
    if (document.webkitFullscreenElement) {
      document.webkitExitFullscreen();
    }
  });
  // 再生開始時にも inline モードを強制
  videoEl.addEventListener('play', () => {
    if (videoEl.webkitPresentationMode && videoEl.webkitPresentationMode !== 'inline') {
      videoEl.webkitSetPresentationMode('inline');
    }
  });
  
  // フルスクリーン／PiP 開始を即終了
  videoEl.addEventListener('webkitbeginfullscreen', () => {
    if (videoEl.webkitExitFullscreen) videoEl.webkitExitFullscreen();
  });
  videoEl.addEventListener('webkitpresentationmodechanged', () => {
    if (videoEl.webkitPresentationMode !== 'inline') {
      videoEl.webkitSetPresentationMode('inline');
    }
  });
  videoEl.addEventListener('enterpictureinpicture', () => {
    if (document.exitPictureInPicture) document.exitPictureInPicture();
  });
  
  // ビデオ自身へのタップを無効化（クリックは親要素でキャッチ）
  videoEl.style.pointerEvents = 'none';
}
